module.exports = __webpack_public_path__ + "fonts/Manrope-VariableFont_wght.efe7827.ttf";